import { FluidOutputReportScreen } from "app/screens/residents/show/FluidOutputReportScreen";

export default function FluidOutputReportPage() {
  return <FluidOutputReportScreen />;
}
